/** A link to the template an import file is built from. */
export function DataImportSampleFile() {
  return (
    <p>
      <a className="me-1" href={`${process.env.PUBLIC_URL}/ContactDetailsSheet.csv`}>
        Click here
      </a>
      to download the contact import sheet template.
    </p>
  );
}

export default DataImportSampleFile;
